import store from '@/store';
import CalculateFMCService from '@/services/DataProcess/CalculateFMCService';

const notableProximityDistanceWatcher = {
  unwatchers: [],

  init() {
    this.watchOpenedDetail();
  },

  watchOpenedDetail() {
    const unwatch = store.watch(
      (state) => state.ancientNotableIndividualResult.openedDetail,
      async (newValue, oldValue) => {
        if (newValue !== oldValue && newValue && newValue.id) {
          store.commit('ancientNotableIndividualResult/setNotableProximityResult', []);

          const sourceDataResult = await store.dispatch('ancientProxSourceData/fetchNotableIndividualSourceData');
          if (!sourceDataResult) return;

          await this.setTargetAndRun(sourceDataResult.sourceData, newValue.sourceCodes);
        }
      }
    );

    this.unwatchers.push(unwatch);
  },

  async setTargetAndRun(sourceData, sourceCodes) {
    const resolveAncientSource = CalculateFMCService.codeDataToArray(sourceData);
    if (!resolveAncientSource.isSuccess) return;
    
    const targetSourceData = resolveAncientSource.result.filter(x => x[0] === sourceCodes);
    
    if (targetSourceData.length) {
      
      CalculateFMCService.onSetTarget(targetSourceData);
    }

    await this.runModernDistance();
  },

  async runModernDistance() {
    try {
      const sourceDataResult = await store.dispatch('modernSourceData/fetchModernSourceData');
      if (!sourceDataResult) return;

      const resolveSource = CalculateFMCService.codeDataToArray(sourceDataResult.sourceData);
      if (resolveSource.isSuccess) {
        CalculateFMCService.onSetSource(resolveSource.result);
      }

      CalculateFMCService.dataObject.maxDistOutPut = 10;
      const calculatedResult = await CalculateFMCService.calculateDistance(0);
      
      store.commit('ancientNotableIndividualResult/setNotableProximityResult', calculatedResult);
    } catch (error) {
      console.error('notableProximityDistanceWatcher error:', error);
    }
  },

  cleanup() {
    this.unwatchers.forEach(unwatch => unwatch());
    this.unwatchers = [];
  },
};

export default notableProximityDistanceWatcher;
